var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable i18next/no-literal-string -- Dev tools don't use translations */
import { useMemo } from 'react';
import { Typography } from '@lucidlink/uicore';
import { useSerializedStats } from '../../../query-hooks';
import { MetricsTable } from './components';
export const NetworkMetrics = ({ stats }) => {
    _react_refresh_temp_2();
    const { query: { data: serializedStats }, } = useSerializedStats('network', stats);
    const metrics = useMemo(() => {
        if (!serializedStats) {
            return undefined;
        }
        return [
            {
                name: 'Pending Requests',
                value: serializedStats?.pendingRequests,
            },
            {
                name: 'All Requests',
                value: serializedStats?.requests,
            },
            {
                name: 'Request Timeouts',
                value: serializedStats?.timeouts,
            },
        ];
    }, [serializedStats]);
    return metrics ? (_jsx(MetricsTable, { data: metrics })) : (_jsx(Typography, { color: "negative", kind: "h5", children: "Cannot load Network metrics" }));
};
_react_refresh_temp_1 = NetworkMetrics;
$RefreshReg$(_react_refresh_temp_1, "NetworkMetrics");
_react_refresh_temp_2(NetworkMetrics, "k0uoxYknZnRVwSi4YJ838faW2Ms=", false, () => [useSerializedStats]);
